import { getOrganization } from '@/data/organizations';
import { Session, Role } from '@/models/user';

export const mockUser: Session = {
  id: 'ae8a45c6-8f89-46b7-a051-c727d3efdb02',
  email: 'j.doe@ipcinfo.org',
  name: 'John Doe',
  roles: [Role.USER, Role.ORG_DATA_ADMIN, Role.ORG_USER_ADMIN],
  fileCount: 0,
  threads: [],
  organizations: [getOrganization('ae8a45c6-8f89-46b7-a051-c727d3efdb02')],
};
